import { GAODING_BUSINESS_ID, GAODING_CHANNEL_ID } from "@/constants/apiConfig";
import request from "@/utils/request";
import requestgd from "@/utils/requestGaoding";
import { getUserDeviceId } from "@gaoding/user-device-id";

/**
 * 获取多坑位可弹出的投放信息集合
 * https://yapi.gaoding.com/project/1536/interface/api/150193
 * @param {Array<{position: string, filter?: string}>} data
 * @returns {AxiosPromise}
 */
export function getDeliveryByPosition(data, header = {}) {
  return request({
    method: "post",
    url: `/delivery-pits/modules/batch-pull`,
    ignoreMessage: true,
    headers: {
      ...header,
      "x-guest-token": getUserDeviceId(),
    },
    data,
    cache: true,
  });
}

/**
 * 获取投放具体信息
 * https://yapi.gaoding.com/project/1536/interface/api/150185
 */
export function getDeliveryDetailByModuleId(position, module_id) {
  return request({
    method: "get",
    url: `/delivery-pits/${position}/modules/${module_id}`,
    ignoreMessage: true,
    headers: {
      "x-guest-token": getUserDeviceId(),
    },
  });
}

/**
 * 获取坑位可弹出的投放信息集合
 * https://yapi.gaoding.com/project/1536/interface/api/150178
 */
export function getDeliveryDetail(position) {
  return request({
    method: "get",
    url: `/delivery-pits/${position}/modules`,
    headers: {
      "x-guest-token": getUserDeviceId(),
    },
    ignoreMessage: true,
  });
}

/**
 * nps用户反馈提交
 * https://yapi.gaoding.com/project/1536/interface/api/154473
 * https://yapi.gaoding.com/project/901/interface/api/94271
 * @param {{
 *    grade?: number,
 *    option_value?: Array<string>,
 *    fill_content?: string,
 *    module_id?: number,
 *    survey_id?: number,
 *    origin_url?: string,
 *    diy_feedback?: string
 * }} data
 * @returns {AxiosPromise}
 */
export function submitNps(data) {
  return request({
    method: "post",
    url: `/nps/feedback`,
    headers: {
      "x-guest-token": getUserDeviceId(),
    },
    data,
  });
}

/**
 *
 * @param {{
 * initial,
 * page_num,
 * page_size,
 * category_code: "topic-pin"|”topic-material”|”topic-boards”
 * }} params
 * @returns
 */
export function getSeoKeywordList(query) {
  return request({
    url: "/seo-keywords",
    query,
  });
}

/**
 *
 * @param {{
 * keyword,
 * matchModel,
 * }} query
 * @returns
 */
export function getSeoKeywordMatch(query) {
  return request({
    url: "/seo-keywords/match",
    query,
  });
}
/**
 * 获取关键词信息
 * @param {{
 *  keyword: string,
 *  category_code: "topic-pin"|”topic-material”|”topic-boards”
 * }}
 * @returns
 */
export function getKeyWordInfo({ keyword, category_code }) {
  return request({
    url: `/seo-categories/${category_code}/keywords/${keyword}`,
  });
}

/**
 * 获取当前页面的内链关键词列表
 * 产品文档：https://doc.huanleguang.com/pages/viewpage.action?pageId=248320981
 * @param {{ current_url, title }} param0
 * @returns
 */
export function getSeoInlinks({ current_url, title }) {
  return request({
    url: "/seo-inlinks",
    query: {
      current_url,
      title,
    },
    timeout: 2000,
    ignoreError: true,
    ignoreMessage: true,
  })
    .then((res) => (Array.isArray(res) ? res : []))
    .catch(() => {
      return [];
    });
}

/**
 * 获取营销日历列表
 */
export function getCalendarList(query, { ignoreError } = {}) {
  return request({
    url: "/coms/marketing-calendars",
    query,
    ignoreError: ignoreError,
  });
}

/**
 * 获取营销日历详情
 */
export function getCalendarDetails(id, query) {
  return request({
    url: `/coms/marketing-calendars/${id}`,
    query,
  });
}

/**
 * 获取轻舟界面配置
 * @template T
 * @param {Object} query
 * @param {string} query.position 界面标识
 * @param {boolean=} query.ignoreError
 * @returns {Promise<T extends any>}
 */
export function getQingzhouConfig({ position, ignoreError, ...query }) {
  return request({
    url: `/exhibitions/${position}/resource`,
    query,
    ignoreError,
  });
}

/**
 * @typedef {{
 *    id: string,
 *    parent_id: string,
 *    weight: number,
 *    name: string,
 *    description: string,
 *    priority: number,
 *    business_id: number,
 *    category_code: string,
 *    updated_at: Date,
 *    created_at: Date,
 *    level: number,
 *    children : Category[]
 * }} Category
 * 获取文章分类树
 * @param {{
 * code: string
 * }} [query] 类型CODE，只支持第一层级的筛选
 * @returns {HUABANResponse<Category[]>}
 */
export function getArticleCategories(query) {
  return request({
    url: "/coms/oc/article-categories/tree",
    query,
  });
}

/**
 * @typedef {{
 *  created_at: Date,
 *  updated_at: Date,
 *  created_by: number,
 *  updated_by: number,
 *  id: number,
 *  article_code: string,
 *  business_id: number,
 *  channel_ids: string,
 *  category_id: string,
 *  category_code: string,
 *  category_parent_list: string,
 *  category_name: string,
 *  title: string,
 *  content_id: string,
 *  url: string,
 *  description: string,
 *  remark: string,
 *  priority: number,
 *  extra: string,
 *  status: number,
 *  is_third_updated: number,
 *  thumb: string,
 * }} ArticleItem
 */

/**
 * @typedef {{
 *  created_at: Date,
 *  updated_at: Date,
 *  created_by: number,
 *  updated_by: number,
 *  id: number,
 *  keywords: string,
 *  title: string,
 *  description: string,
 *  nickname: string,
 *  alts: string,
 * }} Seo
 */

/**
 * 获取文章列表
 * @param {Partial<{
 *  category_code: string,
 *  query_cond: string,
 *  include_children: boolean,
 *  page_num: number|string,
 *  page_size: number,
 *  sort: string
 * }>} [query]
 * @returns {HUABANResponse<{pagination: Pagination, data: ArticleItem[]}>}
 */
export function getArticleList(query) {
  return request({
    url: "/coms/oc/article-contents",
    query,
  });
}

/**
 * @typedef {{
 *  created_at: Date,
 *  updated_at: Date,
 *  id: number,
 *  article_code: string,
 *  business_id: number,
 *  channel_ids: string,
 *  category_id: string,
 *  category_code: string,
 *  category_parent_list: string,
 *  category_name: string,
 *  title: string,
 *  content_id: string,
 *  content: string,
 *  content_url: string,
 *  content_type: number,
 *  keyword: string,
 *  url: string,
 *  thumb: string,
 *  description: string,
 *  remark: string,
 *  priority: number,
 *  published_at: Date,
 *  status: number,
 *  deleted: number,
 *  seo: Seo | null,
 *  categories: Omit<Category, "children">[],
 *  extra: string
 * }} Article
 */
/**
 * 获取文章详情
 * @param {string} code
 * @returns {HUABANResponse<Article>}
 */
export function getArticleDetail(code) {
  return request({
    url: `/coms/oc/article-contents/${code}`,
  });
}

/**
 * 批量获取关键词映射
 * https://yapi.gaoding.com/project/1819/interface/api/136720
 * @param {string[]} keywords
 * @param {string} match_model 匹配模式(match|revert) SeoKeywordMatchEnum
 * @returns
 */
export function batchGetKeywordMap(keywords, match_model) {
  return requestgd({
    url: `/v3/oc/seo-keywords/batch-match`,
    method: "post",
    data: {
      keywords,
      match_model,
    },
  });
}

/**
 * 获取关键词所属一级类目
 * https://yapi.gaoding.com/project/2012/interface/api/208007
 * @param {string} keyword 映射词 code
 * @param {string} category_code 栏目页面code
 * @returns {Promise<{
 *  keyword: string,
 *  alias: string,
 *  id: number,
 *  err: number,
 *  message: string,
 * }>}
 */
export function getKeywordColumn(keyword, category_code) {
  return requestgd({
    url: `/v3/oc/seo-keyword-columns/first`,
    query: {
      keyword,
      category_code,
    },
  });
}

/**
 * 获取关键词映射，包含tdk设置
 * https://yapi.gaoding.com/project/2012/interface/api/202395
 * @param {string} keyword 映射词 code
 * @param {string} category 栏目code
 * @returns {Promise<{
 *  mapping_word: string,
 *  search_word: string,
 *  tdk: {
 *    title: string,
 *    desc: string,
 *    keyword: string,
 *  },
 * }>}
 */
export function getSeoKeywords(keyword, category) {
  return requestgd({
    url: `/v3/oc/v2/seo-keywords/match`,
    query: {
      keyword,
      category,
    },
  });
}

export function getGaodingPageConfig(position) {
  return requestgd({
    url: `/v3/oc/exhibitions/${position}/resources`,
    headers: {
      "X-Business-Id": GAODING_BUSINESS_ID,
      "X-Channel-Id": GAODING_CHANNEL_ID,
    },
  });
}

/**
 * 获取 SEO 用户列表
 * @param {{
 *   page: number,
 *   per_page: number,
 * }} query
 * @returns {Promise<{
 *   users: Array<{
 *     user_id: number,
 *     username: string,
 *     urlname: string,
 *     avatar: string,
 *     pin_count: number,
 *     follower_count: number,
 *     board_count: number,
 *     following: boolean,
 *     profile: object,
 *     pins: Array<object>,
 *   }>,
 *   total: number,
 *   err: number,
 *   status: number,
 *   message: string,
 * }>}
 */
export function getSeoUserList(query) {
  return request({
    url: "/v3/listpage/users",
    query,
  });
}
